var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FullCalendar',{ref:"AllReservationsCalendar",attrs:{"options":_vm.config}}),_vm._v(" "),_c('ReservationModal',{attrs:{"slotId":_vm.updateReservationModal},on:{"close":function($event){_vm.updateReservationModal = null}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }